import { Card, Form, Offcanvas } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { DashSquareFill, PlusSquareFill } from "react-bootstrap-icons";
import ReactQuill from "react-quill-new";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import CommonQuill from "../../components/editor/CommonQuill";
import HelperService from "../../utility/HelperService";

interface AddAcademyProps {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

type FormData = {
  title: string;
  slug: string;
  createdBy: string;
  meta_description: string;
  keywords: string;
};

const AddAcademy = ({ show, handleClose, data }: AddAcademyProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    trigger
  } = useForm<FormData>();
  const [isLoading, setLoading] = useState(false);
  const [logo, setLogo] = useState<File | null>(null);
  const [images, setImages] = useState<any[]>([{}]);
  const [value, setValue] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [fileError, setFileError] = useState<string>("");
  const descriptionQuillRef = useRef<any>(null);
  const shortDescQuillRef = useRef<any>(null);
  const [iesaAcademy, setIesaAcademy] = useState([{ title: "", logo: "" }]);
  const [buttons, setButtons] = useState([
    { title: "", url: "", highlight: false },
  ]);
  const [customErrors, setCustomErrors] = useState<{
    description?: string;
    short_description?: string;
  }>({});
  const [ourOfferings, setOurOfferings] = useState([{ title: "", logo: "" }]);
  const [ourProjects, setOurProjects] = useState([
    { title: "", description: "", url: "" },
  ]);
  const [eLearningCourses, setELearningCourses] = useState([
    { title: "", description: "", logo: "", url: "" },
  ]);
  const [academyPartners, setAcademyParatners] = useState([
    { title: "", logo: "" },
  ]);
  const [eLearningPortal, setELearningPortal] = useState({
    title: "",
    button_title: "",
    url: "",
  });

  useEffect(() => {
    const storedUser = localStorage.getItem("UserData");
    const userData = storedUser ? JSON.parse(storedUser) : null;

    if (data) {
      reset({
        title: data.title,
        slug: data.slug,
        keywords: data?.keywords,
        createdBy: userData?.fullName || "",
        meta_description: data?.meta_description,
      });
      setLogo(null);
      setShortDescription(data.short_description || "");
      setValue(data.description);
      setIesaAcademy(
        data.why_iesa?.length > 0 ? data.why_iesa : [{ title: "", logo: null }],
      );
      setOurOfferings(
        data.our_offering?.length > 0
          ? data.our_offering
          : [{ title: "", logo: null }],
      );

      setOurProjects(
        data.our_projects?.length > 0
          ? data.our_projects
          : [{ title: "", description: "", url: "" }],
      );
      setELearningCourses(
        data.e_learning_courses?.length > 0
          ? data.e_learning_courses
          : [{ title: "", logo: null, description: "", url: "" }],
      );
      setAcademyParatners(
        data.academy_partners?.length > 0
          ? data.academy_partners
          : [{ title: "", logo: null }],
      );
      setButtons(
        data.buttons?.length > 0
          ? data.buttons
          : [{ title: "", url: "", highlight: false }],
      );
      if (data?.e_learning_portal) {
        setELearningPortal({
          title: data.e_learning_portal.title || "",
          button_title: data.e_learning_portal.button_title || "",
          url: data.e_learning_portal.url || "",
        });
      }
    }
  }, [data, show]);
  const imageHandler = (quillRef: any) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.click();

    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("file", file);
      formData.append("storage", "ABOUT_US");

      try {
        const res: any = await WebService.fileUploadAPI({
          action: "upload",
          body: formData,
        });

        const imageUrl = res?.data?.url;
        if (!imageUrl) {
          toast.error("Image upload failed");
          return;
        }

        if (!quillRef?.current) return;

        const editor = quillRef.current.getEditor();
        const range = editor.getSelection(true);

        editor.insertEmbed(range.index, "image", imageUrl);
        editor.setSelection(range.index + 1);
      } catch {
        toast.error("Image upload failed");
      }
    };
  };
    const isQuillEmpty = (value?: string) => {
    if (!value) return true;

    // remove html tags, &nbsp; and spaces
    const text = value
      .replace(/<(.|\n)*?>/g, "")
      .replace(/&nbsp;/g, "")
      .trim();

    return text.length === 0;
  };
  const validateInfoTab = async () => {
    const titleValid = await trigger(["title"]);

    const newErrors: any = {};

    if (isQuillEmpty(value)) {
      newErrors.description = "Description is required";
    }

    if (isQuillEmpty(shortDescription)) {
      newErrors.short_description = "Short Description is required";
    }

    setCustomErrors(newErrors);

    // 🔥 IMPORTANT: return actual validity
    return titleValid && !newErrors.description;
  };
  const onSubmit =  async (request: FormData) => {
    if (fileError) {
      toast.error(fileError);
      return;
    }
        const valid = await validateInfoTab();
    if (!valid) {
      toast.error("Please fill required fields");
      return;
    }
    const storedUser = localStorage.getItem("UserData");
    const userData = storedUser ? JSON.parse(storedUser) : null;
    setLoading(true);
    const formData = new FormData();
    formData.append("title", request.title);
    formData.append("type", "STATIONARY_ENERGY");
    formData.append("slug", request.slug);
    formData.append("short_description", shortDescription);

    if (data?._id) {
      formData.append("id", data._id);
    }

    if (logo) {
      formData.append("logo", logo);
    }

    const editor = descriptionQuillRef.current?.getEditor();
    const html = editor?.root.innerHTML || "";
    formData.append("description", html);
    if (!data?._id && userData?._id) {
      formData.append("createdBy", userData._id);
    }
    formData.append("meta_description", request.meta_description);
    formData.append("keywords", request.keywords);

    if (
      iesaAcademy.length > 0 &&
      iesaAcademy.every(
        (item) => item.title && item.logo && Object.keys(item).length !== 0,
      )
    ) {
      formData.append("why_iesa", JSON.stringify(iesaAcademy));
    }
    const validOfferings = ourOfferings.filter(
      (item) => item.title && item.logo,
    );

    if (validOfferings.length > 0) {
      formData.append("our_offering", JSON.stringify(validOfferings));
    }

    const validProjects = ourProjects
  .filter((item) => item.title && item.description)
  .map((item) => ({
    title: item.title,
    description: item.description || "",
    url: item.url || "", // optional
  }));

if (validProjects.length > 0) {
  formData.append("our_projects", JSON.stringify(validProjects));
}

    if (
      eLearningCourses.length > 0 &&
      eLearningCourses.every(
        (c) =>
          c.title &&
          c.description &&
          c.logo &&
          c.url &&
          Object.keys(c).length !== 0,
      )
    ) {
      formData.append("e_learning_courses", JSON.stringify(eLearningCourses));
    }

    if (
      academyPartners.length > 0 &&
      academyPartners.every(
        (c) => c.title && c.logo && Object.keys(c).length !== 0,
      )
    ) {
      formData.append("academy_partners", JSON.stringify(academyPartners));
    }

    if (
      eLearningPortal.title &&
      eLearningPortal.button_title &&
      eLearningPortal.url
    ) {
      formData.append("e_learning_portal", JSON.stringify(eLearningPortal));
    }
    const validButtons = buttons.filter(
      (b) => b.title && typeof b.highlight === "boolean",
    );

    if (validButtons.length > 0) {
      formData.append("buttons", JSON.stringify(validButtons));
    }

    WebService.fileUploadAPI({
      action: `academy/addAcademy`,
      body: formData,
    })
      .then((res: any) => {
        toast.success(res.message);
        setLoading(false);
        handleClose();
      })
      .catch((err: any) => {
        setLoading(false);
        toast.error(err.response?.data?.message || "An error occurred");
      });
  };
  const ALLOWED_IMAGE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/svg+xml",
  ];
  const uploadFile = (file: File, index: number, type: string) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("storage", "ACADEMY");
    WebService.fileUploadAPI({
      action: "upload",
      body: formData,
    })
      .then((res: any) => {
        if (!res?.data?.url) return;

        const url = res.data.url;
        if (type === "WHY_IESA") {
          iesaAcademy[index].logo = url;
          setIesaAcademy([...iesaAcademy]);
        }

        if (type === "OUR_OFFERING") {
          ourOfferings[index].logo = url;
          setOurOfferings([...ourOfferings]);
        }

        if (type === "E_LEARNING_COURSES") {
          eLearningCourses[index].logo = url;
          setELearningCourses([...eLearningCourses]);
        }

        if (type === "ACADEMY_PARTNERS") {
          academyPartners[index].logo = url;
          setAcademyParatners([...academyPartners]);
        }

        toast.success(res.message || "Image uploaded");
      })
      .catch((err: any) => {
        toast.error(err.response?.data?.message || "Upload failed");
      });
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={() => {
          handleClose();
        }}
        placement="end"
        className="offcanvas-custom"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{data ? "Edit" : "Add"}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form>
            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Main Content
              </span>

              <Form.Group className="mb-2" controlId="title">
                <Form.Label className="label">Title</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter title"
                  {...register("title", { required: "Title is required" })}
                />
                {errors.title && (
                  <div className="error-message">{errors.title.message}</div>
                )}
              </Form.Group>
              <Form.Group className="mb-2" controlId="slugField">
                <Form.Label className="label">Slug</Form.Label>{" "}
                <span className="text-danger">*</span>
                <Form.Control
                  type="text"
                  placeholder="Enter slug"
                  {...register("slug")}
                />
              </Form.Group>

              <Form.Group className="mb-2" controlId="eventDescription">
                <Form.Label className="label">Description</Form.Label>
             
                 <CommonQuill
                  ref={descriptionQuillRef}
                  value={value}
                  onChange={setValue}
                  storage="ACADEMY"
                  initialHtml={show && data?.description ? HelperService.normalizeResizeHtml(data.description) : undefined}
                  onClearError={() =>
                    setCustomErrors((p) => ({
                      ...p,
                      description: undefined,
                    }))
                  }
                />
                {customErrors.description && (
                  <div className="error-message">
                    {customErrors.description}
                  </div>
                )}
              </Form.Group>
              <Form.Group className="mb-2" controlId="eventDescription">
                <Form.Label className="label">Short Description</Form.Label>
                <CommonQuill
                  ref={shortDescQuillRef}
                  value={shortDescription}
                  onChange={setShortDescription}
                  storage="ACADEMY"
                  initialHtml={show && data?.short_description ? HelperService.normalizeResizeHtml(data.short_description) : undefined}
                  onClearError={() =>
                    setCustomErrors((p) => ({
                      ...p,
                      short_description: undefined,
                    }))
                  }
                />
                {customErrors.short_description && (
                  <div className="error-message">
                    {customErrors.short_description}
                  </div>
                )}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="label">Buttons</Form.Label>

                {buttons.map((item, index) => (
                  <div
                    key={index}
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData("buttonIndex", index.toString())
                    }
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      const fromIndex = Number(
                        e.dataTransfer.getData("buttonIndex"),
                      );
                      if (fromIndex === index) return;

                      const updated = [...buttons];
                      const [moved] = updated.splice(fromIndex, 1);
                      updated.splice(index, 0, moved);
                      setButtons(updated);
                    }}
                    style={{ cursor: "move" }}
                  >
                    <div className="d-flex align-items-center mb-2">
                      {/* DRAG ICON */}
                      <span className="drag-icon">⋮⋮</span>

                      {/* TITLE */}
                      <Form.Control
                        placeholder="Button title"
                        value={item.title}
                        className="me-2"
                        onChange={(e) => {
                          const updated = [...buttons];
                          updated[index].title = e.target.value;
                          setButtons(updated);
                        }}
                      />

                      {/* URL */}
                      <Form.Control
                        placeholder="Button URL"
                        value={item.url}
                        className="me-2"
                        onChange={(e) => {
                          const updated = [...buttons];
                          updated[index].url = e.target.value;
                          setButtons(updated);
                        }}
                      />

                      {/* HIGHLIGHT */}
                      <Form.Check
                        type="checkbox"
                        label="Highlight"
                        checked={item.highlight}
                        className="me-2"
                        onChange={(e) => {
                          const updated = [...buttons];
                          updated[index].highlight = e.target.checked;
                          setButtons(updated);
                        }}
                      />

                      {/* ADD */}
                      <PlusSquareFill
                        size={35}
                        className="me-2 cursor-pointer"
                        onClick={() =>
                          setButtons([
                            ...buttons,
                            { title: "", url: "", highlight: false },
                          ])
                        }
                      />

                      {/* REMOVE */}
                      {buttons.length > 1 && (
                        <DashSquareFill
                          size={35}
                          className="cursor-pointer"
                          onClick={() =>
                            setButtons(buttons.filter((_, i) => i !== index))
                          }
                        />
                      )}
                    </div>
                  </div>
                ))}
              </Form.Group>
              <Form.Group className="mb-2" controlId="createdBy">
                <Form.Label className="label">Created By</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Created by user"
                  {...register("createdBy")}
                  value={watch("createdBy") || ""}
                  disabled
                />
              </Form.Group>
            </Card>
            {/*  El earning portals */}
            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                E-Learning Portal
              </span>

              <Form.Group className="mb-3">
                <Form.Label className="label">Portal Title</Form.Label>
                <Form.Control
                  placeholder="Enter portal title"
                  value={eLearningPortal.title}
                  onChange={(e) =>
                    setELearningPortal({
                      ...eLearningPortal,
                      title: e.target.value,
                    })
                  }
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="label">Button Title</Form.Label>
                <Form.Control
                  placeholder="Enter button title"
                  value={eLearningPortal.button_title}
                  onChange={(e) =>
                    setELearningPortal({
                      ...eLearningPortal,
                      button_title: e.target.value,
                    })
                  }
                />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label className="label">Portal URL</Form.Label>
                <Form.Control
                  placeholder="https://example.com"
                  value={eLearningPortal.url}
                  onChange={(e) =>
                    setELearningPortal({
                      ...eLearningPortal,
                      url: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Card>

            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Why IESA Academy
              </span>
              <Form.Group className="mb-3">
                <Form.Label className="label">Why IESA Academy</Form.Label>
                <p
                  className="text-primary mt-1"
                  style={{ fontSize: "13px" }}
                >
                  Note: Please upload an image of size:{" "}
                  <strong>42 × 37 px</strong> in{" "}
                  <strong>.png, .jpeg, .jpg or .svg</strong> format.
                </p>
                {iesaAcademy.map((item, index) => (
                  <div
                    key={index}
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData("trustIndex", index.toString())
                    }
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      const fromIndex = Number(
                        e.dataTransfer.getData("trustIndex"),
                      );
                      if (fromIndex === index) return;

                      const updated = [...iesaAcademy];
                      const [moved] = updated.splice(fromIndex, 1);
                      updated.splice(index, 0, moved);
                      setIesaAcademy(updated);
                    }}
                  >
                    <div className="d-flex align-items-start mb-2">
                      <span className="drag-icon mx-2 my-2">⋮⋮</span>
                      <div style={{ flex: 1 }} className="highlight-item">
                        <div className="flex-1 w-100">
                          <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                              const input = e.target as HTMLInputElement;
                              const file = input.files?.[0];

                              if (!file) return;

                              if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
                                const msg =
                                  "Image format not supported. Please upload PNG, JPG, JPEG or SVG image.";

                                setFileError(msg);
                                toast.error(msg);
                                input.value = "";
                                return;
                              }

                              if (file) {
                                uploadFile(file, index, "WHY_IESA");
                              }
                              setFileError("");
                            }}
                          />

                          {item.logo && (
                            <img
                              src={item.logo}
                              style={{ maxHeight: 120, marginTop: 5 }}
                            />
                          )}

                          <div className="d-flex mt-2">
                            <Form.Control
                              placeholder="Title"
                              value={item.title}
                              onChange={(e) => {
                                const updated = [...iesaAcademy];
                                updated[index].title = e.target.value;
                                setIesaAcademy(updated);
                              }}
                            />

                            <PlusSquareFill
                              className="ms-2 cursor-pointer"
                              onClick={() =>
                                setIesaAcademy([
                                  ...iesaAcademy,
                                  { title: "", logo: "" },
                                ])
                              }
                            />

                            {iesaAcademy.length > 1 && (
                              <DashSquareFill
                                className="ms-2 cursor-pointer"
                                onClick={() =>
                                  setIesaAcademy(
                                    iesaAcademy.filter((_, i) => i !== index),
                                  )
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Form.Group>
            </Card>

            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Our Offering
              </span>
              <Form.Group className="mb-3">
                <Form.Label className="label">Our Offering</Form.Label>
                <p
                  className="text-primary mt-1"
                  style={{ fontSize: "13px" }}
                >
                  Note: Please upload an image of size:{" "}
                  <strong>33 × 19 px</strong> in{" "}
                  <strong>.png, .jpeg, .jpg or .svg</strong> format.
                </p>
                {ourOfferings.map((item, index) => (
                  <div
                    key={index}
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData("keyAreaIndex", index.toString())
                    }
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      const fromIndex = Number(
                        e.dataTransfer.getData("keyAreaIndex"),
                      );
                      if (fromIndex === index) return;

                      const updated = [...ourOfferings];
                      const [moved] = updated.splice(fromIndex, 1);
                      updated.splice(index, 0, moved);
                      setOurOfferings(updated);
                    }}
                    style={{ cursor: "move" }}
                  >
                    <div className="d-flex align-items-start mb-2">
                      <span className="drag-icon mx-2 my-2">⋮⋮</span>
                      <div style={{ flex: 1 }} className="highlight-item">
                        <div className="flex-1 w-100">
                          <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                              const input = e.target as HTMLInputElement;
                              const file = input.files?.[0];

                              if (!file) return;

                              if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
                                const msg =
                                  "Image format not supported. Please upload PNG, JPG, JPEG or SVG image.";

                                setFileError(msg);
                                toast.error(msg);
                                input.value = "";
                                return;
                              }

                              if (file) {
                                uploadFile(file, index, "OUR_OFFERING");
                              }
                              setFileError("");
                            }}
                          />

                          {item.logo && (
                            <img
                              src={item.logo}
                              style={{ maxHeight: 120, marginTop: 5 }}
                            />
                          )}

                          <div className="d-flex mt-2">
                            <Form.Control
                              placeholder="Title"
                              value={item.title}
                              onChange={(e) => {
                                const updated = [...ourOfferings];
                                updated[index].title = e.target.value;
                                setOurOfferings(updated);
                              }}
                            />

                            <PlusSquareFill
                              className="ms-2 cursor-pointer"
                              onClick={() =>
                                setOurOfferings([
                                  ...ourOfferings,
                                  { title: "", logo: "" },
                                ])
                              }
                            />

                            {ourOfferings.length > 1 && (
                              <DashSquareFill
                                className="ms-2 cursor-pointer"
                                onClick={() =>
                                  setOurOfferings(
                                    ourOfferings.filter((_, i) => i !== index),
                                  )
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Form.Group>
            </Card>

            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Our Projects
              </span>

              <Form.Group className="mb-3">
                <Form.Label className="label">Our Projects</Form.Label>

                {ourProjects.map((item, index) => (
                  <div
                    key={index}
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData("projectIndex", index.toString())
                    }
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      const fromIndex = Number(
                        e.dataTransfer.getData("projectIndex"),
                      );
                      if (fromIndex === index) return;

                      const updated = [...ourProjects];
                      const [moved] = updated.splice(fromIndex, 1);
                      updated.splice(index, 0, moved);
                      setOurProjects(updated);
                    }}
                    style={{ cursor: "move" }}
                  >
                    <div className="d-flex align-items-start mb-3">
                      <span className="drag-icon">⋮⋮</span>

                      <div className="flex-1 w-100">
                        {/* TITLE */}
                        <Form.Control
                          placeholder="Title"
                          value={item.title}
                          className="mb-2"
                          onChange={(e) => {
                            const updated = [...ourProjects];
                            updated[index].title = e.target.value;
                            setOurProjects(updated);
                          }}
                        />

                        {/* URL */}
                        {/* <Form.Control
                          placeholder="Project URL"
                          value={item.url}
                          className="mb-2"
                          onChange={(e) => {
                            const updated = [...ourProjects];
                            updated[index].url = e.target.value;
                            setOurProjects(updated);
                          }}
                        /> */}

                        {/* DESCRIPTION */}
                        <ReactQuill
                          theme="snow"
                          value={item.description}
                          onChange={(val) => {
                            const updated = [...ourProjects];
                            updated[index].description = val;
                            setOurProjects(updated);
                          }}
                        />
                         

                        {/* ACTIONS */}
                        <div className="d-flex mt-2 gap-2">
                          <PlusSquareFill
                            size={28}
                            className="cursor-pointer"
                            onClick={() =>
                              setOurProjects([
                                ...ourProjects,
                                { title: "", description: "", url: "" },
                              ])
                            }
                          />

                          {ourProjects.length > 1 && (
                            <DashSquareFill
                              size={28}
                              className="cursor-pointer"
                              onClick={() =>
                                setOurProjects(
                                  ourProjects.filter((_, i) => i !== index),
                                )
                              }
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Form.Group>
            </Card>

            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                E-Learning Courses
              </span>

              <Form.Group className="mb-3">
                <Form.Label className="label">E-Learning Courses</Form.Label>
                <p
                  className="text-primary mt-1"
                  style={{ fontSize: "13px" }}
                >
                  Note: Please upload an image of size:{" "}
                  <strong>366 × 204 px</strong> in{" "}
                  <strong>.png, .jpeg, .jpg or .svg</strong> format.
                </p>
                {eLearningCourses.map((item, index) => (
                  <div
                    key={index}
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData("courseIndex", index.toString())
                    }
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      const fromIndex = Number(
                        e.dataTransfer.getData("courseIndex"),
                      );
                      if (fromIndex === index) return;

                      const updated = [...eLearningCourses];
                      const [moved] = updated.splice(fromIndex, 1);
                      updated.splice(index, 0, moved);
                      setELearningCourses(updated);
                    }}
                    style={{ cursor: "move" }}
                  >
                    <div className="d-flex align-items-start mb-3">
                      <span className="drag-icon mx-2 my-2">⋮⋮</span>
                      <div style={{ flex: 1 }} className="highlight-item">
                        <div className="flex-1 w-100">
                          {/* LOGO */}
                          <Form.Control
                            type="file"
                            accept="image/*"
                            className="mb-2"
                            onChange={(e) => {
                              const input = e.target as HTMLInputElement;
                              const file = input.files?.[0];

                              if (!file) return;

                              if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
                                const msg =
                                  "Image format not supported. Please upload PNG, JPG, JPEG or SVG image.";

                                setFileError(msg);
                                toast.error(msg);
                                input.value = "";
                                return;
                              }

                              if (file) {
                                uploadFile(file, index, "E_LEARNING_COURSES");
                              }
                              setFileError("");
                            }}
                          />

                          {item.logo && (
                            <img
                              src={item.logo}
                              style={{ maxHeight: 80, marginBottom: 10 }}
                            />
                          )}

                          {/* TITLE */}
                          <Form.Control
                            placeholder="Course Title"
                            className="mb-2"
                            value={item.title}
                            onChange={(e) => {
                              const updated = [...eLearningCourses];
                              updated[index].title = e.target.value;
                              setELearningCourses(updated);
                            }}
                          />

                          {/* URL */}
                          <Form.Control
                            placeholder="Course URL"
                            className="mb-2"
                            value={item.url}
                            onChange={(e) => {
                              const updated = [...eLearningCourses];
                              updated[index].url = e.target.value;
                              setELearningCourses(updated);
                            }}
                          />

                          {/* DESCRIPTION */}
                          <ReactQuill
                            theme="snow"
                            value={item.description}
                            onChange={(val) => {
                              const updated = [...eLearningCourses];
                              updated[index].description = val;
                              setELearningCourses(updated);
                            }}
                            className="editor"
                          />

                          {/* ACTIONS */}
                          <div className="d-flex mt-2 gap-2">
                            <PlusSquareFill
                              size={28}
                              className="cursor-pointer"
                              onClick={() =>
                                setELearningCourses([
                                  ...eLearningCourses,
                                  {
                                    title: "",
                                    description: "",
                                    logo: "",
                                    url: "",
                                  },
                                ])
                              }
                            />

                            {eLearningCourses.length > 1 && (
                              <DashSquareFill
                                size={28}
                                className="cursor-pointer"
                                onClick={() =>
                                  setELearningCourses(
                                    eLearningCourses.filter(
                                      (_, i) => i !== index,
                                    ),
                                  )
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Form.Group>
            </Card>

            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Academy Partners
              </span>
              <Form.Group className="mb-3">
                <Form.Label className="label"> Academy Partners</Form.Label>
                <p
                  className="text-primary mt-1"
                  style={{ fontSize: "13px" }}
                >
                  Note: Please upload an image of size:{" "}
                  <strong>173 × 46 px</strong> in{" "}
                  <strong>.png, .jpeg, .jpg or .svg</strong> format.
                </p>
                {academyPartners.map((item, index) => (
                  <div
                    key={index}
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData("partnerIndex", index.toString())
                    }
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      const fromIndex = Number(
                        e.dataTransfer.getData("partnerIndex"),
                      );
                      if (fromIndex === index) return;

                      const updated = [...ourOfferings];
                      const [moved] = updated.splice(fromIndex, 1);
                      updated.splice(index, 0, moved);
                      setAcademyParatners(updated);
                    }}
                    style={{ cursor: "move" }}
                  >
                    <div className="d-flex align-items-start mb-2">
                      <span className="drag-icon mx-2 my-2">⋮⋮</span>
                      <div style={{ flex: 1 }} className="highlight-item">
                        <div className="flex-1 w-100">
                          <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                              const input = e.target as HTMLInputElement;
                              const file = input.files?.[0];

                              if (!file) return;

                              if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
                                const msg =
                                  "Image format not supported. Please upload PNG, JPG, JPEG or SVG image.";

                                setFileError(msg);
                                toast.error(msg);
                                input.value = "";
                                return;
                              }

                              if (file) {
                                uploadFile(file, index, "ACADEMY_PARTNERS");
                              }
                              setFileError("");
                            }}
                          />

                          {item.logo && (
                            <img
                              src={item.logo}
                              style={{ maxHeight: 120, marginTop: 5 }}
                            />
                          )}

                          <div className="d-flex mt-2">
                            <Form.Control
                              placeholder="Title"
                              value={item.title}
                              onChange={(e) => {
                                const updated = [...academyPartners];
                                updated[index].title = e.target.value;
                                setAcademyParatners(updated);
                              }}
                            />

                            <PlusSquareFill
                              className="ms-2 cursor-pointer"
                              onClick={() =>
                                setAcademyParatners([
                                  ...academyPartners,
                                  { title: "", logo: "" },
                                ])
                              }
                            />

                            {academyPartners.length > 1 && (
                              <DashSquareFill
                                className="ms-2 cursor-pointer"
                                onClick={() =>
                                  setAcademyParatners(
                                    academyPartners.filter(
                                      (_, i) => i !== index,
                                    ),
                                  )
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Form.Group>
            </Card>

            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Media
              </span>
              <Form.Group className="mb-2" controlId="logo">
                <p
                  className="text-primary mt-1"
                  style={{ fontSize: "13px" }}
                >
                  Note: Please upload an image of size:{" "}
                  <strong>183 × 95 px</strong> in{" "}
                  <strong>.png, .jpeg, .jpg or .svg</strong> format.
                </p>
                <Form.Label className="label">Logo</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  className="custom-image-upload"
                  onChange={(e) => {
                    const input = e.target as HTMLInputElement;
                    const selectedFile = input.files?.[0];

                    if (!selectedFile) return;

                    if (!ALLOWED_IMAGE_TYPES.includes(selectedFile.type)) {
                      setFileError(
                        "Image format not supported. Please upload PNG, JPG, JPEG or SVG. image",
                      );
                      // console.log(fileError)
                      //      toast.error(fileError);
                      setLogo(null);
                      input.value = ""; // reset input
                      return;
                    }

                    // ✅ valid
                    setFileError("");
                    setLogo(selectedFile);
                  }}
                />
                {fileError && (
                  <p className="text-danger mt-1" style={{ fontSize: "13px" }}>
                    {fileError}
                  </p>
                )}
              </Form.Group>
              {(logo || data?.logo) && (
                <div className="mb-2 event-image">
                  <img
                    src={logo ? URL.createObjectURL(logo) : data?.logo}
                    alt="Event"
                    style={{
                      maxWidth: "100%",
                      maxHeight: 200,
                      objectFit: "contain",
                    }}
                  />
                </div>
              )}
            </Card>

            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                SEO
              </span>
              <Form.Label className="label">
                Meta Description
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Meta Description"
                {...register("meta_description", {
                  required: "Meta description is required",
                })}
              />
              {errors.meta_description && (
                <div className="error-message">
                  {errors.meta_description.message}
                </div>
              )}
              <Form.Group className="mb-2" controlId="eventName">
                <Form.Label className="label">
                  Keywords <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter keywords"
                  {...register("keywords", {
                    required: "Keywords are required",
                  })}
                />
                {errors.keywords && (
                  <div className="error-message">{errors.keywords.message}</div>
                )}
              </Form.Group>
            </Card>
          </Form>
        </Offcanvas.Body>
        <div className="d-flex justify-content-end p-3">
          <CustomButton
            isLoading={isLoading}
            label="Save"
            className="w-100"
            onClick={handleSubmit(onSubmit)}
          />
        </div>
      </Offcanvas>
    </>
  );
};

export default AddAcademy;
